/**
 * Tammy chooses how this photo looks on the product page.
 * Menu cards stay square either way.
 */

import type { DetailFit } from '../utils/imageDisplay';

interface Props {
  value: DetailFit;
  onChange: (fit: DetailFit) => void;
  disabled?: boolean;
}

export default function ImageDetailFitToggle({ value, onChange, disabled }: Props) {
  return (
    <fieldset className="mt-2 space-y-1" disabled={disabled}>
      <legend className="text-xs font-medium text-gray-700">
        On the product page (when someone opens this item)
      </legend>
      <div className="flex flex-wrap gap-2">
        <label
          className={`text-xs px-2 py-1 rounded border cursor-pointer ${
            value === 'contain'
              ? 'border-purple-500 bg-purple-50 text-purple-800'
              : 'border-gray-200 text-gray-700 hover:bg-gray-50'
          }`}
        >
          <input
            type="radio"
            name="detail-fit"
            className="sr-only"
            checked={value === 'contain'}
            onChange={() => onChange('contain')}
          />
          Original photo
        </label>
        <label
          className={`text-xs px-2 py-1 rounded border cursor-pointer ${
            value === 'cover'
              ? 'border-purple-500 bg-purple-50 text-purple-800'
              : 'border-gray-200 text-gray-700 hover:bg-gray-50'
          }`}
        >
          <input
            type="radio"
            name="detail-fit"
            className="sr-only"
            checked={value === 'cover'}
            onChange={() => onChange('cover')}
          />
          Fill square
        </label>
      </div>
      <p className="text-xs text-gray-500">
        Menu cards stay square. Original shows the whole file on the cake/item page.
      </p>
    </fieldset>
  );
}
